import { useQuery } from '@tanstack/react-query';
import { api, queryKeys } from '../api/endpoints.ts';

/**
 * SLA de expedientes (`06-backoffice.md` §4.2): verde < 24 h, amarillo < 72 h, rojo ≥ 72 h en la
 * fase actual. Umbrales configurables (por ahora constantes de la consola).
 */
export const SLA_HOURS = { yellow: 24, red: 72 } as const;

export type SlaTone = 'success' | 'warning' | 'danger';

export function slaFor(
  enteredAt: string,
  now: Date,
  thresholds: { yellow: number; red: number } = SLA_HOURS,
): { tone: SlaTone; hours: number; label: string } {
  const hours = Math.max(0, (now.getTime() - Date.parse(enteredAt)) / 3_600_000);
  const tone: SlaTone =
    hours >= thresholds.red ? 'danger' : hours >= thresholds.yellow ? 'warning' : 'success';
  const label =
    hours < 1
      ? 'menos de 1 h'
      : hours < 48
        ? `${Math.floor(hours)} h`
        : `${Math.floor(hours / 24)} días`;
  return { tone, hours, label };
}

/** Hora de referencia de la consola: el reloj de demo si está disponible, si no la del navegador. */
export function useConsoleNow(): Date {
  const clock = useQuery({
    queryKey: queryKeys.clock,
    queryFn: api.getClock,
    retry: false,
    staleTime: 30_000,
  });
  return clock.data ? new Date(clock.data.now) : new Date();
}
